import React, { Component } from "react";
import notfound from "./../asset/images/404.png";

export default class NotFound extends Component {
  render() {
    return (
      <div className="notFoundContainer">
        <img src={notfound} alt="404" />
        <div style={{ minHeight: "40px", height: "40px" }}></div>
        <div>متاسفانه صفحه‌ای که دنبالش میگردی رو پیدا نکردیم...</div>
      </div>
    );
  }
}
